<template>
  <v-app id="inspire">
    <div class="row">
    <div class="text-center">
    <v-overlay 
        :value="overlay"
        :opacity=0.1
    >
      
    </v-overlay>
  </div>
  <v-card
    class="mx-auto col-md-8 mb-12 mt-12"
    style=" z-index:8; padding:10px;"
    center
  >
    <v-card-text class="mb-12">
      <!-- <div>Word of the Day</div> -->
      <div class="row">
        
<!-- drawer here -->
    <!-- header here -->
    <v-content >
      <v-container
        class="topstyle"
      >
        
          <!-- contents here -->
            <!-- <v-sheet
                class="mx-auto"
                elevation="8"
                max-width="800"
                
              > -->

                <v-slide-group
                  v-model="model"
                  class="pa-4"
                  :prev-icon="false ? 'mdi-minus' : undefined"
                  :next-icon="false ? 'mdi-plus' : undefined"
                  :multiple="multiple"
                  :mandatory="true"
                  :show-arrows="true"
                  :center-active="centerActive"
                  flat:true
                >
                  <v-slide-item v-slot:default="{ active, toggle }"  class="mr-5" style="padding:11px;"
                    v-for="mygroup in myGroups"
                    v-bind:key="mygroup.id"
                    @mouseout="windows.location.reload()"
                  >
                    <v-card
                        class="mx-auto ma-4"
                        :flat="true"
                        :loading="false"
                        :outlined="true"
                        :elevation="1"
                        :raised="true"
                        :width="'220'"
                        :height="'350'"
                      >
                      <!-- <a href=""> -->
                        <v-img
                          class="white--text"
                          src="https://rubiesstore.s3.amazonaws.com/696969.png"
                        >
                        
                        </v-img>
                        <v-card-text  class="mb--12" style="text-align: center; padding-bottom: 0px;"><strong>{{mygroup.groupname}}</strong></v-card-text>
                        <v-card-text class="mt--12" style="text-align: center; padding-top: 0px;"><i>{{mygroup.members}} members</i></v-card-text>
                        <v-card-actions v-if="true" style="margin-left: 25%;">
                          <v-btn outlined @click="navigate(mygroup.groupid, mygroup.groupname)" >Get me in</v-btn>
                        </v-card-actions>
                      <!-- </a> -->
                      </v-card>
                  </v-slide-item>



                  <v-slide-item v-slot:default="{ active, toggle }" class="mr-5" style="padding:11px;" >
                    <v-card
                        class="mx-auto ma-4"
                        :flat="true"
                        :loading="false"
                        :outlined="true"
                        :elevation="1"
                        :raised="false"
                        :width="'220'"
                        :height="'350'"
                      >
                      <!-- <a href=""> -->
                        <v-img
                          class="white--text"
                          src="https://rubiesstore.s3.amazonaws.com/696969.png"
                        >
                        </v-img>
                        <v-card-text><strong>ADD NEW CIRCLE</strong></v-card-text>
                        <v-card-actions style="margin-left: 25%;" >
                          <v-btn @click="dialog=true"
                            outlined
                          >NEW</v-btn>
                        </v-card-actions>
                        <!-- </a> -->
                      </v-card>
                  </v-slide-item>

                  <v-slide-item v-slot:default="{ active, toggle }" class="mr-5" v-if="seen" style="padding:11px;"
                    v-for="n in 15"
                    :key="n+100"
                   >
                    <v-card
                        class="mx-auto ma-4"
                        :flat="true"
                        :loading="false"
                        :outlined="true"
                        :elevation="1"
                        :raised="false"
                        :width="'220'"
                        :height="'350'"
                      >
                      <!-- <a href=""> -->
                        <v-img
                          class="white--text"
                          src="https://rubiesstore.s3.amazonaws.com/696969.png"
                        >
                        </v-img>
                        <v-card-text><strong>ADD NEW CIRCLE</strong></v-card-text>
                        <v-card-actions style="margin-left: 25%;" >
                          <v-btn @click="dialog=true"
                            outlined
                          >NEW</v-btn>
                        </v-card-actions>
                        <!-- </a> -->
                      </v-card>
                  </v-slide-item>

                </v-slide-group>
              <!-- </v-sheet> -->
          <!-- /contents here -->
          
      </v-container>
    </v-content>
    
    <!-- dialog here for adding new circle -->
    <new-circle-dialog
        :dialogactive="dialog"
    ></new-circle-dialog>


      </div>
    </v-card-text>
  </v-card>
  </div>
  </v-app>
</template>








<script>
  export default {

    data: () => ({
      model: null,
      overlay:false,
      multiple: false,
      mandatory: false,
      showArrows: true,
      prevIcon: false,
      nextIcon: false,
      centerActive: false,
      dialog: false,
      seen: true,
      items: [
        { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Photos', subtitle: 'Jan 9, 2014' },
        { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Recipes', subtitle: 'Jan 17, 2014' },
        { icon: 'folder', iconClass: 'grey lighten-1 white--text', title: 'Work', subtitle: 'Jan 28, 2014' },
      ],
      items2: [
        { icon: 'assignment', iconClass: 'blue white--text', title: 'Vacation itinerary', subtitle: 'Jan 20, 2014' },
        { icon: 'call_to_action', iconClass: 'amber white--text', title: 'Kitchen remodel', subtitle: 'Jan 10, 2014' },
      ],

      modals:{
            modal0:false,
            modal3: false
        },
        newGroup:{
            phonenumber: localStorage.phonenumber, 
            source: "Web", 
            groupname: "", 
            groupdesc: "",
            jointype: "",
            grouptype: "",
            groupcategory: "",

        },
        phonenumber: localStorage.phonenumber,
        isLoading: false,
        myGroups:{},
        categories:{},
        model: {
          email: '',
          password: ''
        },
        User: {},
        value: localStorage.deviceID,
        size: 300,
        deviceid: localStorage.deviceID,
        formData:{
            phonenumber:localStorage.phonenumber
        }
    }),


    methods: {
        doLoading() {
            this.isLoading = true;
            
            // simulate AJAX
            
            setTimeout(() => {
                this.isLoading = false
            },5000)
        },
        onCancel() {
            console.log('User cancelled the loader.')
        },

        createGroup(){
            this.isLoading = true;
            this.modals.modal3 = false;
            this.newGroup.groupcategory = this.newGroup.grouptype;
            fetch('https://shwvr4uwyh.execute-api.us-east-1.amazonaws.com/dev/creategroup',{
                    method: 'post',
                    body: JSON.stringify(this.newGroup),
                    headers: {
                     'content-type':'application/json'
                    }
                })
                .then(res => res.json())
                .then(res => {
                    console.log(res);
                    
                    if(res.responsecode == "00")
                    {
                        console.log(res);
                        this.isLoading = false;
                        this.$swal.fire(
                            'Success',
                            res.responsemessage,
                            'success'
                        );
                        this.fetchGroups();
                    }else{
                        this.isLoading = false;
                        this.$swal.fire(
                            'Errorr Code: '+res.responsecode,
                            res.responsemessage,
                            'error'
                        )
                    }
                    
                    
                })
                .catch(err => console.log(err))
        },

        fetchGroups(){
            fetch('https://shwvr4uwyh.execute-api.us-east-1.amazonaws.com/dev/getmygroups',{
                    method: 'post',
                    body: JSON.stringify(this.formData),
                    headers: {
                     'content-type':'application/json'
                    }
                })
                .then(res => res.json())
                .then(res => {
                    console.log(res);
                    
                    if(res.data[0].mobilenumber != "")
                    {
                        console.log(res);
                        this.myGroups = res.data;
                        console.log(this.myGroups);
                        this.showArrows = true;
                        // location.reload();
                        this.seen = false;
                    }else{
                        // this.$swal.fire(
                        //     'Errorr',
                        //     res.data[0].responsemessage,
                        //     'danger'
                        // )
                        this.seen = false;
                    }
                    
                })
                .catch(err => console.log(err))

        },

        fetchCategories(){
            fetch('https://shwvr4uwyh.execute-api.us-east-1.amazonaws.com/dev/getcategories',{
                    method: 'post',
                    body: JSON.stringify({you:"you"}),
                    headers: {
                     'content-type':'application/json'
                    }
                })
                .then(res => res.json())
                .then(res => {
                    console.log(res);
                    
                    if(res.data[0].mobilenumber != "")
                    {
                        console.log(res);
                        this.categories = res.data;
                        this.showArrows = true;
                    }else{
                        this.$swal.fire(
                            'Errorr',
                            res.data[0].responsemessage,
                            'danger'
                        )
                    }
                    
                })
                .catch(err => console.log(err))

        },


        navigate(groupid, groupname){
            this.doLoading();
            localStorage.groupid = groupid;
            localStorage.groupname = groupname;
            this.$router.push('dashboard');
        }
    },
    computed: {
        
    },
    created() {
      
        this.showArrows = true;
    },
    mounted() {
        this.fetchGroups();
        this.fetchCategories();
        this.showArrows = true;
    },
  }
</script>